(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-scooter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupHomeScooters = (root = document) => {
      root.querySelectorAll('[data-home-scooter]').forEach((container) => {
        if (container.dataset.homeScooterReady === 'true') return;
        container.dataset.homeScooterReady = 'true';

        const heroImage = container.querySelector('[data-home-scooter-image]');
        const navItems = Array.from(container.querySelectorAll('[data-home-scooter-nav]'));
        const contentBlocks = Array.from(container.querySelectorAll('[data-home-scooter-block]'));
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        let currentIndex = 0;
        let currentDevice = mediaQuery.matches ? 'mobile' : 'desktop';
        let autoplayTimer = null;
        let isPaused = false;
        let imageSwapToken = 0;

        const autoplayEnabled = container.dataset.autoplayEnabled === 'true';
        const autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) * 1000 || 4000;

        const getDevice = () => mediaQuery.matches ? 'mobile' : 'desktop';

        const setActiveState = (index) => {
          contentBlocks.forEach((block) => {
            block.classList.toggle('active', Number(block.dataset.index) === index);
          });
          navItems.forEach((item) => {
            item.classList.toggle('active', Number(item.dataset.index) === index);
          });
        };

        const swapImage = (navItem, device) => {
          if (!heroImage || !navItem) return;

          const mobileSource = container.querySelector('[data-home-scooter-mobile-source]');
          const desktopSrc = navItem.dataset.desktopSrc || navItem.dataset.mobileSrc;
          const mobileSrc = navItem.dataset.mobileSrc || desktopSrc;
          const desktopSrcset = navItem.dataset.desktopSrcset || navItem.dataset.mobileSrcset || '';
          const mobileSrcset = navItem.dataset.mobileSrcset || desktopSrcset;
          const targetSrc = device === 'mobile' ? mobileSrc : desktopSrc;
          const targetSrcset = device === 'mobile' ? mobileSrcset : desktopSrcset;

          if (!targetSrc) return;
          const token = ++imageSwapToken;
          const nextImage = new Image();
          const applyImage = () => {
            if (token !== imageSwapToken) return;
            heroImage.style.opacity = '0';
            window.setTimeout(() => {
              if (token !== imageSwapToken) return;
              if (mobileSource && mobileSrcset) mobileSource.setAttribute('srcset', mobileSrcset);
              if (desktopSrcset) heroImage.setAttribute('srcset', desktopSrcset);
              heroImage.setAttribute('src', desktopSrc);
              heroImage.style.opacity = '1';
            }, 120);
          };

          nextImage.onload = applyImage;
          nextImage.onerror = () => {
  if (token !== imageSwapToken) return;
  console.warn('Home Scooter: banner image failed to load.');
};
          if (targetSrcset) {
            nextImage.srcset = targetSrcset;
            nextImage.sizes = '100vw';
          }
          nextImage.src = targetSrc;
        };

        const updateVariant = (index, forceUpdate = false) => {
          const navItem = navItems.find((item) => Number(item.dataset.index) === index);
          const device = getDevice();

          if (!navItem) return;
          setActiveState(index);
          if (forceUpdate || device !== currentDevice || index !== currentIndex) {
            swapImage(navItem, device);
          }
          currentDevice = device;
          currentIndex = index;
        };

        const goToNext = () => {
          const nextIndex = (currentIndex + 1) % navItems.length;
          updateVariant(nextIndex, true);
        };

        const startAutoplay = () => {
          stopAutoplay();
          if (!autoplayEnabled || navItems.length <= 1) return;
          autoplayTimer = window.setInterval(() => {
            if (!isPaused && !document.hidden) goToNext();
          }, autoplaySpeed);
        };

        const stopAutoplay = () => {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        };

        container.addEventListener('mouseenter', () => { isPaused = true; });
        container.addEventListener('mouseleave', () => { isPaused = false; });
        container.addEventListener('focusin', () => { isPaused = true; });
        container.addEventListener('focusout', () => { isPaused = false; });

        // Start the first autoplay interval only after the page load event.
        // Manual selection before load cancels that deferred startup.
        let initialAutoplayPending = false;
        const beginInitialAutoplay = () => {
          initialAutoplayPending = false;
          startAutoplay();
        };
        const cancelInitialAutoplay = () => {
          if (!initialAutoplayPending) return;
          window.removeEventListener('load', beginInitialAutoplay);
          initialAutoplayPending = false;
        };

        container.homeScooterUpdate = updateVariant;

        navItems.forEach((item) => {
          const index = Number(item.dataset.index);
          item.addEventListener('click', () => {
            cancelInitialAutoplay();
            updateVariant(index, true);
            startAutoplay();
          });
          item.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              cancelInitialAutoplay();
              updateVariant(index, true);
              startAutoplay();
            }
          });
        });

        // <picture> automatically selects the correct image on viewport changes.
        const handleDeviceChange = () => { currentDevice = getDevice(); };
        if (typeof mediaQuery.addEventListener === 'function') {
          mediaQuery.addEventListener('change', handleDeviceChange);
        } else if (typeof mediaQuery.addListener === 'function') {
          mediaQuery.addListener(handleDeviceChange);
        }

        updateVariant(0);
        if (document.readyState === 'complete') {
          beginInitialAutoplay();
        } else {
          initialAutoplayPending = true;
          window.addEventListener('load', beginInitialAutoplay, { once: true });
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => setupHomeScooters());
    document.addEventListener('shopify:section:load', (event) => setupHomeScooters(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const selected = event.target.closest('[data-home-scooter-block], [data-home-scooter-nav]');
      const container = selected && selected.closest('[data-home-scooter]');
      if (!selected || !container || typeof container.homeScooterUpdate !== 'function') return;
      container.homeScooterUpdate(Number(selected.dataset.index), true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
